import { LoginAttempt } from './login-attempt.model';

export class LoginAttemptCollection {
    public items: LoginAttempt[];
    public totalItems: number;
}
